import React from 'react';
import Powers from './powers.jsx';
import Ranges from './ranges.jsx';

class Performance extends React.Component {

  state = {
    class: "",
  }

  constructor(props) {
    super(props);

    this.state.selectedClass = this.props.selectedClass
    this.state.powers = this.props.powers
    this.state.ranges = this.props.ranges
    this.state.range = this.props.selectedRange
    this.state.selectedFrequency = this.props.selectedFrequency

    // if selected range is not setled, set first ranges active
    if(!!this.state.range == false || Object.keys(this.state.range).length == 0) {
      this.state.range = this.getFirstRanges(this.props.selectedClass);
    }
  }
  getFirstRanges(powerClass) {
    let data = {};

    this.props.ranges.map(range => {
      data[range.option] = {
        from: range.classes[powerClass]["units"][0].min,
        to: range.classes[powerClass]["units"][0].max,
        unit: range.classes[powerClass]["units"][0].unit,
      }
    });

    return data;
  }
  getFirstRangesWithoutFromTo(powerClass) {
    let data = {};

    this.props.ranges.map(range => {
      data[range.option] = {
        unit: range.classes[powerClass]["units"][0].unit,
      }
    });

    return data;
  }
  render() {
    if(Object.keys(this.state.range)) {
      return (
        <>
          {/* <Powers
            powers={this.props.powers}
          /> */}
          <Ranges
            ranges={this.props.ranges}
          />
      </>
    )
    }
  }
}

export default Performance;